// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseTeamWrapper_wrapper_2jb-o","image":"BaseTeamWrapper_image_1IGhr","text":"BaseTeamWrapper_text_1aZBY"};